import React from "react";
import {
  Box,
  Button,
  Typography,
  useTheme,
  useMediaQuery,
  Stack,
  CardMedia,
  keyframes,
} from "@mui/material";
// import Img2 from "./cardImg/contactManagement22.png";
import Img2 from "./img/Chatbot22.png";
import img6 from "./img/chatbot54.png";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const fadeInTop = keyframes`
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Card1 = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const isXs = useMediaQuery(theme.breakpoints.down("xs"));
  // xs usually < 600px — Small mobile phones (very rare)

  const isSm = useMediaQuery(theme.breakpoints.between("xs", "sm"));
  // 600px and down — Most mobile phones (Portrait)

  const isMd = useMediaQuery(theme.breakpoints.between("sm", "md"));
  // 600px to 900px — Large mobiles, small tablets (Landscape mobile/tablet)

  const isLg = useMediaQuery(theme.breakpoints.between("md", "lg"));
  // 900px to 1200px — Tablets & Small Laptops (e.g., Chromebooks, netbooks)

  const isXl = useMediaQuery(theme.breakpoints.up("lg"));
  // 1200px and above — Full-size Laptops, Desktops, Wide monitors

  const handleClick1 = () => {
    // navigate("/solution1");
    navigate("/products", { state: { index: 0 } });
  };
  return (
    <Box
      sx={{
        animation: `${fadeInTop} 1s ease-in-out`,
        display: "flex",
        flexDirection: {
          xl: "column",
          lg: "column",
          md: "column",
          sm: "column",
          xs: "row",
        },
        backgroundColor: "#E1EFFF",
        color: "#FFFFFF",
        borderRadius: "8px",
        overflow: "hidden",
        width: "100%",
        height: "100%",
        //border: "1px solid red"
      }}
    >
      {/* Text Section */}
      <Box
        sx={{
          // border: "1px solid green",
          textAlign: {
            xl: "left",
            lg: "left",
            sm: "left",
            xs: "justify",
          }, // Center align text

          width: { xs: "100%", xl: "100%", lg: "100%", sm: "100%" },
          // marginTop: { xl: "20px", lg: "20px", md: "20px" },
        }}
      >
        <Stack
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
            // border: "1px solid red",
            justifyContent: "flex-start",
          }}
        >
          <Stack
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
              // border: "2px solid green",
              // alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            <Stack
              sx={{
                height: "80px",
                width: "80px",
                // border: "1px solid red",
                marginLeft: "8px",
                marginTop: "12px",
              }}
            >
              <img
                src={Img2}
                alt="Forex Management"
                style={{
                  width: "90%", // Image takes full width
                  height: "90%",
                  // padding: "4px",
                  padding: isXs
                    ? "0px"
                    : isSm
                      ? "0px"
                      : isMd
                        ? "8px"
                        : isLg
                          ? "8px"
                          : "8px",
                  objectFit: "contain",
                }}
              />
            </Stack>
          </Stack>
          <Stack
            sx={{
              fontSize: {
                lg: "27px",
                xl: "27px",
                md: "27px",
                xs: "18px",
                sm: "28px",
              },
              lineHeight: {
                lg: "30px",
                xl: "30px",
                md: "30px",
                xs: "23px",
                sm: "36px",
              },
              fontFamily: "'Poppins', sans-serif",
              fontWeight: "600",
              color: "rgba(12, 12, 12, 0.8)",
              fontFamily: "'Roboto', sans-serif",
              textAlign: "left",
              // border: "1px solid blue",
              marginLeft: "16px",
            }}
          >
            {" "}
            No-code chatbot builder
          </Stack>
          <Stack
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: 1,
              lineHeight: {
                lg: "21px",
                xl: "21px",
                md: "21px",
                xs: "20px",
                sm: "20px",
              },
              // fontSize: "18px",
              fontSize: {
                lg: "17px",
                xl: "17px",
                md: "17px",
                xs: "16px",
                sm: "20px",
              },
              fontFamily: "'Roboto', sans-serif",
              fontWeight: {
                lg: "400",
                xl: "400",
                xs: "400",
                sm: "400",
              },
              color: "text.secondary",
              marginLeft: "16px",
              // paddingRight : "4px",
              marginRight: { xl: "8px", lg: "0px" },
            }}
          >
            <Stack>
              Build intelligent chatbots effortlessly no coding required- with a simple and intuitive drag-and-drop interface.
            </Stack>
          </Stack>
          <Stack sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
            <Stack>
              <Button
                variant="outlined"
                sx={{
                  color: "rgb(5, 78, 146)",
                  border: "1px solid rgb(5, 78, 146)",

                  "&:hover": {
                    color: "rgb(31, 133, 192)", // Hover background
                    borderColor: "rgb(31, 133, 192)", // Hover border
                  },
                  textTransform: "none",
                  fontSize: isMd || isSm || isXs ? "12px" : "16px",
                  width: "fit-content",
                  borderRadius: "8px",
                  marginLeft: "16px",
                  marginTop: {
                    xl: "4px",
                    lg: "4px",
                    md: "0px",
                    sm: "0px",
                    xs: "12px",
                  },
                  // marginLeft: {
                  //   xl: "100px",
                  //   lg: "96px",
                  //   md: "66px",
                  //   sm: "0px",
                  //   xs: "64px",
                  // },
                  display: "none",
                }}
                size="small"
                onClick={handleClick1}
              >
                Know More
              </Button>
            </Stack>
          </Stack>
        </Stack>
      </Box>

      {/* Image Section */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: { xl: "370px", lg: "420px", sm: "280px", xs: "140px" },
          marginTop: "20px",
          // border: "1px solid red",
          width: { xs: "50%", xl: "100%", lg: "100%", sm: "100%" },
        }}
      >
        <Stack
          sx={{
            width: { xs: "50%", xl: "100%", lg: "80%", sm: "80%" },
            height: "100%",
          }}
        >
          <CardMedia
            component="img"
            image={img6}
            alt="card1Img"
            sx={{ height: "100%", width: "100%", objectFit: "contain" }}
          />
        </Stack>
      </Box>
    </Box>
  );
};

export default Card1;
